import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  UserNotificationClosedResponse,
  userNotificationClosedResponseSchema,
} from '../../../common/validations'
import { Id } from '../../../common/types'
import { isFeatureAccessDenied } from '../../utils/isFeatureAccessDenied'

import { post } from 'api/apiClient'

export const useAPICloseUserNotification = (
  notificationId: Id,
  options?: UseMutationOptions<UserNotificationClosedResponse, ErrorResponse>
) =>
  useMutation({
    mutationFn: () =>
      post(
        API_ENDPOINTS.CLOSE_NOTIFICATION.replace(
          ':id',
          notificationId.toString()
        ),
        {},
        userNotificationClosedResponseSchema
      ),
    ...options,
    throwOnError: isFeatureAccessDenied,
  })
